import React, { useState, useEffect } from 'react';

import './styles/message.css';

export default function Message({ message, duration, color, onClose }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
        onClose({});
      }, (duration || 2.5) * 1000);
    }
  }, [message, duration]);

  return (
    <>{visible && <div className="message-container" style={{ backgroundColor: color || "#ed4c5c" }}>{message}</div>}</>
  );
}
